import { useAngularContext } from 'AngularContext';
import {
    type LessonIguanaObject,
    type StreamIguanaClass,
    type ContentAccessHelperClass,
    type Stream,
    snakeCaseStream,
} from 'Lessons';

export const useLaunchableLessonsLocalePackIdsByStream = (stream?: Stream) => {
    const Stream = useAngularContext().get<StreamIguanaClass>('Lesson.Stream');
    const ContentAccessHelper = useAngularContext().get<ContentAccessHelperClass>('ContentAccessHelper');

    if (!stream) return [];

    const iguanaStream = Stream.new(snakeCaseStream(stream));

    const launchableIguanaLessons = iguanaStream.lessons.filter(lesson =>
        ContentAccessHelper.canLaunch(lesson as LessonIguanaObject),
    );

    return launchableIguanaLessons.map(lesson => lesson.locale_pack.id);
};
